import { NextSeo } from 'next-seo';
import Head from 'next/head';

const SignUp = () => {
  return (
    <>
      <Head>
        <meta httpEquiv="refresh" content={`0;url=/login/`}></meta>
      </Head>

      <NextSeo
        nofollow={process.env.NOINDEX_FLAG === 'true'}
        noindex={process.env.NOINDEX_FLAG === 'true'}
        title="Signup | Loadsmart"
      />
    </>
  );
};

export default SignUp;
